// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputGroup_f8tJP {
  display : grid;
  grid-template-rows: 2rem 44px 1.5rem;
  width: 100%;
  margin-bottom: 16px;
}

.title_U267K {
  background-color: white;
  border-bottom: 1px solid #e5e5e5;
}

.title_U267K > button {
  grid-row-start: 1;
  grid-row-end: 3;
  grid-column-start: 2;
}

.formBody_Usn5A {
  height: 100%;
}

.editorPanel_ryYTb {
  position : relative;
  height : 100%;
  border-left : 1px solid #e5e5e5;
  width : 450px;
}

.editorPanel_ryYTb.full_l5DFA {
  width : 100%;
  border-left : none;
}

.metadata__wV1N {
  margin-bottom: 32px;
}`, "",{"version":3,"sources":["webpack://./src/editors/enums/EnumEditorStyle.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oCAAoC;EACpC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".inputGroup {\n  display : grid;\n  grid-template-rows: 2rem 44px 1.5rem;\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.title {\n  background-color: white;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.title > button {\n  grid-row-start: 1;\n  grid-row-end: 3;\n  grid-column-start: 2;\n}\n\n.formBody {\n  height: 100%;\n}\n\n.editorPanel {\n  position : relative;\n  height : 100%;\n  border-left : 1px solid #e5e5e5;\n  width : 450px;\n}\n\n.editorPanel.full {\n  width : 100%;\n  border-left : none;\n}\n\n.metadata {\n  margin-bottom: 32px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputGroup": `inputGroup_f8tJP`,
	"title": `title_U267K`,
	"formBody": `formBody_Usn5A`,
	"editorPanel": `editorPanel_ryYTb`,
	"full": `full_l5DFA`,
	"metadata": `metadata__wV1N`
};
export default ___CSS_LOADER_EXPORT___;
